/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EAdvancedOptionsTabs {
  Geofences,
  Garmin,
  WorkOrders
}
